import React, { forwardRef, type MutableRefObject } from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { type ProjectType, CORE_PROJECT } from '@atlassian/jira-common-constants/src/project-types';
import { useIntl } from '@atlassian/jira-intl';
import { useProjectSidebarNavigation } from '@atlassian/jira-navigation-apps-sidebar-common';
import { type LinkProps, Link } from '@atlassian/react-resource-router';
import messages from './messages';
import { getSettingsUrl } from './utils';

type Props = {
	projectKey: string;
	projectType: ProjectType;
	isSimplified: boolean;
	onClick: () => void;
};

export const ProjectSettingsItem = forwardRef(
	(
		{ onClick, projectKey, projectType, isSimplified }: Props,
		ref: MutableRefObject<HTMLElement | null> | ((instance: HTMLElement | null) => void) | null,
	) => {
		const { formatMessage } = useIntl();

		const { data } = useProjectSidebarNavigation({
			matchParams: { projectKey },
		});

		let navigationResourceData;

		if (projectType === CORE_PROJECT) {
			navigationResourceData = data?.jiraWorkManagementNavData;
		} else {
			navigationResourceData = data?.jiraSoftwareNavData;
		}

		return (
			<DropdownItem
				ref={ref}
				onClick={onClick}
				component={({ onClick: handleClick, ...props }) => (
					<Link
						{...props}
						// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
						onClick={handleClick as LinkProps['onClick']}
						to={getSettingsUrl(
							projectType,
							isSimplified,
							projectKey,
							navigationResourceData?.permissionInfo,
						)}
					/>
				)}
			>
				{formatMessage(messages.settings)}
			</DropdownItem>
		);
	},
);
